import type { RateType } from 'paintscout'

export default function toSaveableRateType(rateType: string): RateType {
  switch (rateType) {
    case 'sqftWalls':
      return 'sqft_walls' as RateType
    case 'sqftCeiling':
      return 'sqft_ceiling' as RateType
    case 'sqftFloor':
      return 'sqft_floor' as RateType
    default:
      return rateType as RateType
  }
}
